import { useCallback, useEffect, useState } from "react";

import { useRef } from "react";

const useInfiniteScroll = (request, collection) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  let res = useRef();

  const sendRequest = useCallback(async () => {
    if (!collection) {
      setHasMore(false);
      return;
    }

    try {
      setLoading(true);
      res.current = await request(page);

      if (res.current?.data?.status === true) {
        const data = res.current.data.data;
        const { links } = data.pagination ?? {};
        setHasMore(!!links?.next_page_url);
        setList((prev) => [...prev, ...data[collection]]);
      } else {
        setList([]);
        setHasMore(false);
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err);
      setHasMore(false);
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [page]);

  const observer = useRef(); // (*)
  const lastListElementRef = useCallback(
    // (*)
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const reFetch = () => {
    setList([]);
    setHasMore(true);
    setPage(1);
    sendRequest();
  }

  useEffect(() => {
    sendRequest();
  }, [sendRequest, page]);

  return { loading, setLoading, error, list, setList, reFetch, res: res.current, lastListElementRef };
};

export default useInfiniteScroll;
